export const DsfWorkFrame = dsf.defineAsyncComponent("DsfWorkFrame", () =>
  import(/*webpackChunkName:"platform_pc_homepage"*/ "./workFrame.vue")
);

const ctrls = { DsfWorkFrame };

const install = dsf.createDsfVueInstall("platform", ctrls);

export { install };
export default install;
